module.exports = __webpack_public_path__ + "static/media/flow02.aa317462.svg";